import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Paper, BottomNavigation, BottomNavigationAction, Badge } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useMenuStructure } from '../../hooks/useMenuStructure';
import { useBrand } from '../../../../context/BrandContext';

const StyledBottomNav = styled(BottomNavigation)<{ primaryColor?: string }>(({ primaryColor = '#556ee6' }) => ({
  backgroundColor: '#2a3042',
  height: 60,
  borderTop: '1px solid rgba(255, 255, 255, 0.1)',
  '& .MuiBottomNavigationAction-root': {
    color: 'rgba(255, 255, 255, 0.6)',
    minWidth: 'auto',
    padding: '6px 12px',
    '&.Mui-selected': {
      color: primaryColor,
    },
    '& .MuiBottomNavigationAction-label': {
      display: 'none !important',
    },
  },
}));

const StyledPaper = styled(Paper)({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 1100,
  boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.15)',
  paddingBottom: 'env(safe-area-inset-bottom, 0px)',
  backgroundColor: '#2a3042',
});

const Icon: React.FC<{ icon: string }> = ({ icon }) => (
  <i 
    className={icon} 
    style={{ 
      fontSize: 24, 
      color: 'inherit',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }} 
  />
);

const MobileBottomNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const menuItems = useMenuStructure();
  const { brand } = useBrand();

  const navItems = menuItems.filter(item => item.path && !item.subMenu?.length);

  const currentValue = navItems.findIndex(item => item.path === location.pathname);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    const selectedItem = navItems[newValue];
    if (selectedItem?.path) {
      navigate(selectedItem.path);
    }
  };

  return (
    <StyledPaper elevation={3}>
      <StyledBottomNav
        primaryColor={brand.primaryColor}
        value={currentValue !== -1 ? currentValue : false}
        onChange={handleChange}
        showLabels={false}
      >
        {navItems.map((item, index) => (
          <BottomNavigationAction
            key={item.id || index}
            icon={
              item.icon ? (
                item.badge && item.badge > 0 ? (
                  <Badge 
                    badgeContent={item.badge} 
                    color="error"
                    max={99}
                    sx={{
                      '& .MuiBadge-badge': {
                        fontSize: '0.6rem',
                        height: '16px',
                        minWidth: '16px',
                        padding: '0 4px',
                      }
                    }}
                  >
                    <Icon icon={item.icon} />
                  </Badge>
                ) : (
                  <Icon icon={item.icon} />
                )
              ) : undefined
            }
          />
        ))}
      </StyledBottomNav>
    </StyledPaper>
  );
};

export default MobileBottomNav;
